<template>
  <v-container grid-list-lg>
    <v-layout row wrap>
      <v-flex md6>
        <h1 class="headline">Mission</h1>
        <vcl-code class="mt-2" v-if="!loaded"></vcl-code>
        <p class="mt-2" v-else>{{ mission }}</p>
      </v-flex>
      <v-flex md6>
        <h1 class="headline">Vision</h1>
        <vcl-code class="mt-2" v-if="!loaded"></vcl-code>
        <p class="mt-2" v-else>{{ vision }}</p>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { VclCode } from 'vue-content-loading';
import axios from 'axios'
export default {
  components: {
    VclCode
  },
  data(){
    return {
      mission: '',
      vision: '',
      orgCharts: [],
      loaded: false,
    }
  },
  created(){
    axios.get('/api/about')
      .then(data => {
        this.mission = data.data.mis_vis_go[0].config_value
        this.vision = data.data.mis_vis_go[1].config_value
        this.orgCharts = data.data.org_chart
        this.loaded = true
      }).catch(e => {
        console.log(e)
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HomePage/About/VisionMission.vue